export const doctorConsultationDetailsTranslations = {
    en: {
        personalDetails: "Personal Details",
        healthCamp: "Health Camp",
        tokenNo: "Token No",
        beneficiaryName: "Beneficiary Name",
        campDate: "Camp Date",
        createdBy: "Created By",

        consultationDetails: "Consultation Details",
        diseasesAndSubDiseases: "Diseases & Sub-diseases",
        otherDiseases: "Other Diseases",
        advice: "Advice",
        observation: "Observation",
        referralInfo: "Referral Info",

        notAvailable: "N/A",
        none: "None"
    },
    mr: {
        personalDetails: "वैयक्तिक तपशील",
        healthCamp: "आरोग्य शिबिर",
        tokenNo: "टोकन क्रमांक",
        beneficiaryName: "लाभार्थीचे नाव",
        campDate: "शिबिर तारीख",
        createdBy: "तयार केले",

        consultationDetails: "सल्ला तपशील",
        diseasesAndSubDiseases: "रोग आणि उप-रोग",
        otherDiseases: "इतर रोग",
        advice: "सल्ला",
        observation: "निरीक्षण",
        referralInfo: "संदर्भ माहिती",

        notAvailable: "उपलब्ध नाही",
        none: "काहीही नाही"
    }
};
